module.exports = __webpack_public_path__ + "static/rpi.6415abc7.png";